import { InputMask } from '@react-input/mask';
import axios from 'axios';
import { useEffect, useState } from 'react';
import { FaRegStar, FaRegUser } from "react-icons/fa";
import { FaFaceFrownOpen, FaFaceGrinBeamSweat, FaFaceGrinStars, FaPeoplePulling } from "react-icons/fa6";
import { LuMessageSquareText } from "react-icons/lu";
import { MdOutlineLocalPhone } from "react-icons/md";
import './App.css';
import logo from './assets/Logo.png';
import BoxAlert from './components/boxAlert';
import Label from './components/label';
import Loader from './components/loader';
import NotFound from './components/notFound';
import { NPSScore } from './components/nps';
import Sended from './components/sended';
import { StarRating } from './components/stars';
import { validateClientName } from './scripts/validateClientName';




function App() {


  const [isError, setIsError] = useState(false);
  const [sended, setSended] = useState(false);

  const [company, setCompany] = useState(null);

  const [name, setName] = useState(null);
  const [phone, setPhone] = useState(null);
  const [rating, setRating] = useState(null);
  const [description, setDescription] = useState(null);
  const [recommend, setRecommend] = useState(null);

  const [alert, setAlert] = useState({show: false, title: null, text: null});

  const [loading, setLoading] = useState(true);

  
  useEffect(() => {
    (async () => {
      try {

        const pathParts = window.location.pathname.split("/");

        const params = pathParts[2] ?? null;

        console.log('PARAMS:', params);
        
        const res = await axios.get(`${process.env.REACT_APP_SERVER_URL}/rating/company`, {
          params: {
            params: params
          },
          headers: {
            'x-api-key': process.env.REACT_APP_API_KEY
          }
        })
        
        console.log('RES:', res);

        if(res.status == 200){
          setCompany(res.data);
        }

      } catch (error) {
        console.error('ERROR - INIT SCREEN:', error);
        setIsError(true);

      } finally {
        setLoading(false);
      }

    })();
  }, [])


  useEffect(() => console.log(company), [company]);




  const handleSubmit = async () => {

    try{
      setLoading(true);

      const nameInfo = name ?? 'Anônimo';

      // Valida nome do cliente
      const valName = !name ? true : validateClientName(name);
  
      // Valida telefone do cliente
      let formatPhone;
  
      if (phone) {
        formatPhone = phone.replace(/\(/g, '').replace(/\)/g, '').replace(' ', '').replace(/\-/g, '');
      }
  
      const valPhone = formatPhone && formatPhone.length === 11 ? true : false;
  
  
      if(!valName || (phone && !valPhone) || !description){
        setAlert({show: true, title: 'Alerta', text: `Insira corretamente ${!valName ? 'seu nome completo' : !description ? 'uma descrição da sua experiência' : 'um telefone de contato'} para prosseguir com a avaliação!`});
        return;
      }
      
      if(!rating || !recommend){
        setAlert({show: true, title: 'Alerta', text: `Selecione ${!rating ? 'uma nota' : 'uma change de recomendação'} para prosseguir com a avaliação!`});
        return;
      }

      await axios.post(`${process.env.REACT_APP_SERVER_URL}/rating/submit`, 
        {
          companyId: company.id,
          name: nameInfo,
          phone: phone,
          rating: rating,
          description: description,
          recommend: recommend,
        },
        {
          headers: {
            'x-api-key': process.env.REACT_APP_API_KEY
          }
        }
      ) 

      setSended(true);
      
    } catch (error) {
      console.error('ERROR - HANDLE SUBMIT FUNCTION:', error);
      setAlert({show: true, title: 'Alerta', text: error.response.data.error});
    
    } finally {
      setLoading(false);
    }

  }


  const RenderScoreFace = () => {
    return (
      <>
        {rating && rating < 3 ? (
          <FaFaceFrownOpen size={25} color='#FFD700'/>

        ) : rating && rating == 3 ? (
          <FaFaceGrinBeamSweat size={25} color='#FFD700'/>

        ) : (
          <FaFaceGrinStars size={25} color='#FFD700'/>

        )}
      </>
    )
  }


  return (

    <>
      {loading ? (
        <Loader/>

      ) : isError ? (
        <NotFound/>

      ) : sended ? (
        <Sended companyName={company?.name}/>

      ) : (
        <div className="app">
          <div className="container">

            <div className='title-container'>
              <h1 className='title-page'>Avalie-nos por aqui!</h1>

            </div>

            <div className="sub-container">
              <p className='subtitle-page'>A sua avaliação é muito importante para nós. Compartilhe sua experiência com a gente!</p>

              {company ? (
                <div className='company-container'>
                  {company.image ? (
                    <img className='restaurant-logo' src={company.image} alt='restaurant-logo'/>
                  ) : null}

                  <div className='company-text-area' style={{marginLeft: company.image ? 10 : 0}}>
                    <p className='company-subtitle'>Avaliando:</p>
                    <p className='company-title'>{company.name}</p>
                  </div>
                </div>
              ) : null}

              <div className='input-container'>
                <Label text='Nome completo'>
                  <FaRegUser size={19}/>
                </Label>

                <input 
                  className='input' 
                  type='text' 
                  placeholder='Insira seu nome' 
                  onChange={({target: {value}}) => setName(value)}
                />
              </div>


              <div className='input-container'>
                <Label text='Telefone / Whatsapp'>
                  <MdOutlineLocalPhone size={23}/>
                </Label>

                <InputMask 
                  className='input' 
                  mask='(__) _____-____' 
                  replacement={{_: /\d/}} 
                  value={phone} 
                  placeholder="Número de telefone / whatsapp" 
                  onChange={({ target: { value } }) => setPhone(value)} 
                />
              </div>
              
              <div className='input-container'>
                <Label text='Que nota você nos dá? *'>
                  <FaRegStar size={20}/>
                </Label>
            
                <div style={{display: 'flex', alignItems: 'center', justifyContent: 'flex-start', gap: 15}}>
                  <StarRating rating={rating} onRatingChange={(value) => setRating(value)}/>

                  <RenderScoreFace/>
                </div>
              </div>
              
              <div className='input-container'>
                <Label text='Descreva sua experiência *'>
                  <LuMessageSquareText size={20}/>
                </Label>

                <textarea 
                  className='input' 
                  id='description'
                  type='text' 
                  placeholder='Conte-nos sobre sua experiência no estabelecimento...' 
                  multiple 
                  aria-multiline={false}
                  onChange={({target: {value}}) => setDescription(value)}
                />
              </div>


              <div className='input-container'>
                <Label text='Você nos recomendaria para outra pessoa? *'>
                  <FaPeoplePulling size={20}/>
                </Label>

                <NPSScore score={recommend} onScoreChange={(value) => setRecommend(value)}/>
              </div>

              <button className='submit-button' onClick={() => handleSubmit()}>
                <span className='submit-button-text'>Enviar</span>
              </button>

            </div>
          </div>

          <div className='footer'>
            <a style={{width: 200, display: 'flex', alignItems: 'center', justifyContent: 'center'}} href={'https://www.sofchef.com.br'} target='_blank'>
              <img src={logo} className="app-logo" alt="logo" />
            </a>
          </div>

          <BoxAlert
            show={alert.show}
            title={alert.title}
            text={alert.text}
            onClose={() => setAlert({show: false, title: null, text: null})}
          />

        </div>
      )}

    </>
  );
}

export default App;
